import spid from '@finn-no/spid-sync';

export default {
    dependencies: ['FINN', 'sitesettings', 'accountservice', 'auth'],
    callable(FINN, settings, accountservice, auth) {
        accountservice
            .whenReady()
            .then(getSpidId)
            .then(doSpidCheck);
        function getSpidId(account) {
            return account.loggedIn ? account.userInfo.spidId : 0;
        }
        function doSpidCheck(spidId) {
            if (!window.location.pathname.match('/logout.html')) {
                spid.enableSpidSync({
                    auth,
                    spidClientId: settings.spidClientId,
                    spidHostname: settings.spidHostname,
                    spidId,
                    isProd: settings.isProd,
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/spidSync.js